import { ref, onMounted, onBeforeUnmount, nextTick } from "vue";
import { useCustomScrollbar } from "./useCustomScrollbar";
import { useInitializeWithRetry } from "./useInitializeWithRetry";

/**
 * usePanelScroller composable
 * Provides refs and automatic initialization/cleanup for panels using custom scrollbars and retry logic.
 * Usage:
 *   const { containerRef, contentRef, customScroller, initializeWithRetry } = usePanelScroller();
 */
export function usePanelScroller() {
  const containerRef = ref(null);
  const contentRef = ref(null);
  const customScroller = ref(null);
  const { initialize, destroy } = useCustomScrollbar();

  // Compose the initializeWithRetry function
  const initializeWithRetry = useInitializeWithRetry(
    initialize,
    customScroller,
    containerRef,
    contentRef
  );

  onMounted(() => {
    nextTick(() => {
      initializeWithRetry();
    });
  });

  onBeforeUnmount(() => {
    destroy();
  });

  return {
    containerRef,
    contentRef,
    customScroller,
    initializeWithRetry,
  };
}
